import { ConversationAtom } from "./conversation-atoms";
import React, { createContext, useContext } from "react";

interface Props {
    atom: ConversationAtom;
    children: React.ReactNode;
}

const CurrentConversationContext = createContext<ConversationAtom | null>(null);

export const CurrentConversationProvider: React.FC<Props> = ({
    atom,
    children,
}) => {
    return (
        <CurrentConversationContext.Provider value={atom}>
            {children}
        </CurrentConversationContext.Provider>
    );
};

export function useCurrentConversationContext() {
    const atom = useContext(CurrentConversationContext);

    if (!atom) {
        throw new Error(
            "useCurrentConversationContext must be used within a CurrentConversationProvider"
        );
    }

    return atom;
}
